import React from "react";
import PropTypes from "prop-types";
import SFTypography from "../../../typography";
import { SFStack } from "../../../grid";
import getStyled from "../../../../hooks/getStyled";
import LinearProgress from "@mui/material/LinearProgress";
import { useTranslation } from "react-i18next";

const { styled } = getStyled();

const SFStackStyled = styled(SFStack)(() => ({
  height: "100%",
}));

const SFProgressBarRenderer = (props) => {
  const { styled } = getStyled();

  const StyledProgressBar = styled(LinearProgress)(({ color, theme }) => ({
    color: color,
    backgroundColor: theme.palette.grey225.main,
    height: 5,
    width: 80,
  }));

  const { t } = useTranslation();

  let count = (current, total) => (
    <SFStack direction="row">
      <SFTypography variant="body1bold">{current}</SFTypography>
      <SFTypography variant="body2">
        {t("components.datagrid.progressBarRenderer.valueSeparator")}
        {total}
      </SFTypography>
    </SFStack>
  );

  const { value, color, max } = props.colDef.valueFormatter
    ? props.colDef.valueFormatter(props)
    : props.value;

  let percentage = (value * 100) / max;
  return (
    <SFStackStyled direction="row" spacing={1} alignItems={"center"}>
      <StyledProgressBar
        variant="determinate"
        color={color}
        value={percentage}
      />
      {count(value, max)}
    </SFStackStyled>
  );
};

SFProgressBarRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      value: PropTypes.string,
      color: PropTypes.string,
      max: PropTypes.string,
    }),
  ]),
  colDef: PropTypes.object,
};

export default SFProgressBarRenderer;
